// Customizable Area Start
import React, { Component } from "react";
import { Box, CircularProgress, styled, SxProps, Theme } from "@mui/material";

type ProgressVariants = "white" | undefined;

const CustomLoader = styled(CircularProgress, {
  shouldForwardProp: (prop) => prop !== "customVariant",
})(({ customVariant }: { customVariant: ProgressVariants }) => ({
  color: "#652784",
  ...(customVariant === "white" && {
    color: "#fff",
  }),
}));

interface Props {
  size?: number;
  children?: React.ReactNode;
  wrapperHeight?: number | string;
  loading: boolean;
  customVariant?: "white";
  wrapperStyles?: SxProps<Theme>;
}

class Loader extends Component<Props> {
  render() {
    const {
      loading,
      size = 20,
      wrapperStyles,
      wrapperHeight = 30,
      children,
      customVariant,
    } = this.props;
    return loading ? (
      <Box
        height={wrapperHeight}
        sx={{ ...wrapperStyles }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CustomLoader size={size} customVariant={customVariant} />
      </Box>
    ) : (
      children || null
    );
  }
}

export default Loader;
// Customizable Area End
